import { LoaderFunction, Outlet } from 'react-router-dom';
import { paths } from '@mosey/api-types';
import { createSearchParamsFromObject } from '@mosey/utils/data/api';
import { api } from '../../../utils/fetchApi';

type WizardConfigParams =
  paths['/api/wizard/{wizard_slug}/config']['get']['parameters']['query'];

export const loader: LoaderFunction = async ({
  params: { wizardSlug, wizardVersion },
}) => {
  let url = `/api/wizard/${wizardSlug}/config`;
  const queryParams: WizardConfigParams = {
    version: wizardVersion,
  };

  const searchParams = createSearchParamsFromObject(queryParams);

  if (searchParams.size > 0) {
    url += `?${searchParams.toString()}`;
  }

  return api({
    url,
    method: 'GET',
  });
};

interface Props {
  children?: React.ReactNode;
}

export const Component = ({ children }: Props) => {
  if (children) {
    return children;
  }

  return <Outlet />;
};
